import React, {Component} from 'react';
import PropTypes from 'prop-types';
// import config from '../../../src/globs/config';
// import dataLoad from '../../../src/actions/data-load';
// import { FormattedMessage } from 'react-intl';
import FormattedCurrencyNumberCustom from '../formatted-currency-number-custom';

class PayerRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerStatus: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    console.log('prevProps......... >>>', prevProps);
    // Only update if customerStatus prop changed AND state needs updating
    // Prevent infinite loop in React 19
    if (prevProps.customerStatus !== this.props.customerStatus &&
        this.state.customerStatus !== this.props.customerStatus) {
      this.setState({
        customerStatus: this.props.customerStatus,
      });
    }
  }

  // balanceRefresh = (sapCode) => {
  //   alert(sapCode);
  //   console.log('sapCode', sapCode);
  //   const { props } = this;
  //   // console.log('props are.........', props.customer);
  //   // const payer_sap_code = props.payers[0].payer_sap_code;
  //   const path = `${config.apiContextPath}/so/sales_officers/${props.user.id}/businesses/${props.customer.business.id}/fetch_balance?payer_sap_code=${sapCode}`;
  //   props.dataLoad({
  //     key: 'payers',
  //     url: path,
  //   });


  // }
  render() {
    const { props, state } = this;
    console.log('render props.......***', this.props)
    const spinLoader = props.fetchingBalance && props.fetchingBalance[props.payer.payer_sap_code];
    
    return (
      <div className="multiple-payers" key={props.payer.payer_sap_code}>
        <span className="payer-name">{props.payer.payer_name} ({props.payer.payer_sap_code})</span>
        <div
        //  spin-refresh-icon
          className={`icon-refresh  ${spinLoader ? 'spin-refresh-icon' : ''}`}
          onClick={() => props.balanceRefresh(props.payer.payer_sap_code)}
          // disabled={props.disabledFetchbalance}
        />
        <div className="balance-label">
          {/* <FormattedMessage id="Dashboard.myBalance" />
          <FormattedMessage id="Dashboard.ordersNotInvoiced" /> */}
          <span>Balance</span>
          <span>Orders not invoiced</span>
        </div>
        <div className="balance-amount">
          <span>
            {/* {props.user.currency} {props.payer.sap_digital_order_balance && Number(props.payer.sap_digital_order_balance).toFixed(2) || 0} */}
            <FormattedCurrencyNumberCustom
              value={
                props.payer.sap_digital_order_balance ?
                props.payer.sap_digital_order_balance : 0
              }
              currency={props.payer.currency}
            />
          </span>
          <span>
          <FormattedCurrencyNumberCustom
              value={
                props.payer.orders_not_invoiced_price ?
                props.payer.orders_not_invoiced_price : 0
              }
              currency={props.payer.currency}
            />
          {/* {props.user.currency} {props.payer.orders_not_invoiced_price && Number(props.payer.orders_not_invoiced_price).toFixed(2) || 0} */}
          </span>
        </div>
      </div>
    );
  }
}

PayerRow.propTypes = {
  payer: {
    payer_name: PropTypes.string,
    payer_sap_code: PropTypes.string,
  },
  user: {
    currency: PropTypes.string.isRequired,
  },
  disabledFetchbalance: PropTypes.bool.isRequired,
  fetchingBalance: PropTypes.shape({}).isRequired,
  balanceRefresh: PropTypes.func.isRequired,
};

PayerRow.defaultProps = {
  payer: undefined,
};

export default PayerRow;
